import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {StorageService} from "../../../core/services/storage.service";
import {EventManagerService} from "../../../core/services/event-manager.service";
import { PopupHelperService } from '../../../core/services/popup-helper.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {NgIf} from "@angular/common";
import {ImageWrapperComponent} from "../image-wrapper/image-wrapper.component";

@Component({
  selector: 'app-chat-room-item',
  templateUrl: './chat-room-item.component.html',
  styleUrls: ['./chat-room-item.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    NgIf,
    ImageWrapperComponent
  ]
})
export class ChatRoomItemComponent implements OnInit, OnChanges {

  name: any
  text: any
  avatar: any;
  isActive: boolean = true;
  answeredName: string | null = null;
  @Input() className:any;
  @Input() room:any;
  @Input() showActiveTime:boolean = true;
  @Input() showOptions:boolean = false;
  @Input() updateVariable:any;
  @Output() openChat = new EventEmitter();
  @Output() deleteRoom = new EventEmitter();
  @Output() editRoom = new EventEmitter();
  @Output() onSelect = new EventEmitter();

  localeUserIndexInRoom: any
  openInviteDropDawnOptions: boolean = false;
  localeUserId: string = StorageService.getJsonItem(StorageService.statics.profileData)?._id
  constructor(private eventManagerService: EventManagerService,
              private popupHelperService: PopupHelperService,
              private translateService: TranslateService) { }

  ngOnInit(): void {
    if(this.room.lastMessage){
      this.setLastMessage(this.room.lastMessage)
    }
    this.localeUserIndexInRoom = this.room.accounts.findIndex((x:any)=> x.accountId._id === this.localeUserId)
    this.room.notSeenMessagesCount = this.room.accounts[this.localeUserIndexInRoom].notSeenMessagesCount
    this.eventManagerService.changeRoomMessageComponentEmitter.subscribe((message)=>{
      if((message.roomId._id && this.room._id && this.room._id === message.roomId._id) || (message.roomId && this.room._id && this.room._id === message.roomId) ){
        this.setLastMessage(message)
      }
    })
    this.eventManagerService.seenRoomMessagesEmitter.subscribe((roomId: any)=>{
      if(roomId === this.room._id){
        this.room.notSeenMessagesCount = 0
        this.room.accounts[this.localeUserIndexInRoom].notSeenMessagesCount = 0
      }
    })

    this.eventManagerService.closeDropDawnOptionsEmitter.subscribe(()=>{
      this.openInviteDropDawnOptions = false
    })
  }

  setRoomInfo(){
    if(this.room.type === 'forAdmin'){
      this.name = this.room.key
      let answeredIndex = this.room.accounts.map(function (e: any) {return e.type}).indexOf('player')
      if(answeredIndex !== -1){
        let answeredUser = this.room.accounts[answeredIndex]
        if(answeredUser.accountId._id === this.localeUserId){
          this.answeredName = this.room?.publisherId?.name
          this.avatar  = {avatarUrl: this.room?.publisherId?.avatarUrl, nickname: this.room?.publisherId?.name}
        }else {
          this.answeredName = answeredUser.name
          this.avatar = {avatarUrl: answeredUser.accountId.avatarUrl, nickname: answeredUser.accountId.nickname}
          this.isActive = answeredUser.accountId.online
        }
      }else{
        this.answeredName = this.room.key
        this.avatar = {avatarUrl: '', nickname: this.name}
        this.isActive = false;
      }
    }else if(this.room.type === "group" || this.room.type === 'team'){
      this.name = this.room.key;
      if(this.room.forId && this.room.forId.bannerId){
        this.avatar = {avatarUrl: this.room.image.s3Url, nickname: this.room.forId.title}
      }
    }else if(this.room.type === "individual"){
      for (let i = 0; i < this.room.accounts.length; i++){
        if(this.room?.accounts[i]?.accountId?._id && this.room.accounts[i]?.accountId?._id !== this.localeUserId){
          this.avatar = {avatarUrl: this.room.accounts[i].accountId.avatarUrl, nickname: this.room.accounts[i].accountId.nickname}
          this.isActive = this.room.accounts[i].accountId.online
          this.name = this.room.accounts[i].name
          break
        }
      }
    }
  }
  setLastMessage(message: any){
    if(typeof message === 'string'){
      this.text = message

    }else {
      if (message.delete) {
        this.text = 'Delete message'
      } else if (message.body.type === 'text') {
        this.text = message.body.content
      } else if (message.body.type === 'image') {
        this.text = 'Send image'
      }
    }
  }
  ngOnChanges(){
    if(this.room){
      if(this.localeUserIndexInRoom === undefined){
        this.localeUserIndexInRoom = this.room.accounts.findIndex((x:any)=> x.accountId._id === this.localeUserId)
      }

      if(this.room.accounts[this.localeUserIndexInRoom].notSeenMessagesCount){
        this.room.notSeenMessagesCount = this.room.accounts[this.localeUserIndexInRoom].notSeenMessagesCount
      }
      this.setRoomInfo()
    }
  }

  toggleInviteDropDawnOptions(){
    if(!this.openInviteDropDawnOptions){
      this.eventManagerService.closeDropDawnOptions()
    }
    this.openInviteDropDawnOptions = !this.openInviteDropDawnOptions
  }

  onOpenChat(){
    this.openChat.emit(this.room)
  }

  onDeleteRoom(){
    this.deleteRoom.emit(this.room._id)
  }
  openPopup( ): void {
    const popupSettings = {
      customClass: {
        container:"z-index-9999",
        popup: "bg-000 w-15",
        confirmButton: "pink-button-imp",
        htmlContainer: "color-white",
      },
      icon: 'question',
      text:  this.translateService.instant('are_you_sure'),
      confirmButtonText: this.translateService.instant('yes'),
    }
    this.popupHelperService.printQuestion(popupSettings, '', this.onDeleteRoom, this)
  }

  onEditRoom(){
    this.editRoom.emit(this.room._id)
  }

}
